<div style="max-height: 100vh" class="pptxContainer">
	<sim-dynamic-script #slidejs src="SlideJS.bundle.min.js" />

	<div #canvasContainer style="text-align: center; width: 100%; height: 100%">
		<div
			#pptxCanvas
			style="margin-left: auto; margin-right: auto"
			[style.width.px]="!autoSize ? width : undefined"
			[style.height.px]="!autoSize ? height : undefined"
			[style.width]="autoSize ? '100%' : undefined"
			[style.height]="autoSize ? '100%' : undefined"
		></div>
	</div>
</div>
